// extracted by mini-css-extract-plugin
export default {"control":"Control_control__RT-IE","button":"Control_button__17+dF","approved":"Control_approved__EOSbE","rejected":"Control_rejected__+ZCAh"};